import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AuthRequired } from "@/components/auth/AuthRequired";
import { SubPage } from "@/components/profile/SettingsKit";
import { ActivitySection } from "@/components/settings/ActivitySection";
import { buildHead } from "@/lib/seo";

function ActivityPage() {
  const { t } = useTranslation("activity");
  return (
    <AuthRequired>
      <SubPage title={t("page.title")} subtitle={t("page.subtitle")}>
        <ActivitySection />
      </SubPage>
    </AuthRequired>
  );
}

export const Route = createFileRoute("/_app/settings_/activity")({
  head: () =>
    buildHead({ path: "/settings/activity", title: "Account activity", noindex: true }),
  component: ActivityPage,
});
